import * as stylex from '@stylexjs/stylex';

import { EmptyState, Heading, Paragraph } from '@/libs/serenity-ui';

export function ListBoxNoSearchResults() {
  return (
    <EmptyState style={emptyStateStyles.base}>
      <Heading>No results</Heading>
      <Paragraph>Try adjusting your search or using different keywords</Paragraph>
    </EmptyState>
  );
}

const emptyStateStyles = stylex.create({
  base: {
    paddingBlock: 40,
    paddingInline: 5,
  },
});
